import React, {Component} from 'react'
import propTypes from 'prop-types'
import BaseEditor from './baseEditor'
import CalendarDatePicker from 'containers/calendarDatePicker'

require('./inlineEditor.scss')

class DateEditor extends Component {
  render() {
    const {
      open,
      anchor,
      value,
      onCommit,
      range,
      onCancel,
      allowNone,
      highlightedDates,
      onMonthChange,
      changeOnMonthSelection,
      showSelectedRange,
      ...otherProps
    } = this.props
    let date
    if (value) date = new Date(value)
    return (
        <BaseEditor
            open={open}
            anchor={anchor}
            {...otherProps}
            height={400}
            width={264}
            onClose={onCancel}
            padded={false}>
          <CalendarDatePicker
              range={range}
              date={date}
              onUpdate={v => onCommit(v ? v.getTime() : null)}
              onCancel={onCancel}
              allowNone={allowNone}
              autoFocus
              highlightedDates={highlightedDates}
              onMonthChange={onMonthChange}
              changeOnMonthSelection={changeOnMonthSelection}
              showSelectedRange={showSelectedRange}/>
        </BaseEditor>
    )
  }
}

DateEditor.propTypes = {
  value: propTypes.oneOfType([
    propTypes.instanceOf(Date),
    propTypes.number,
  ]),
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  allowNone: propTypes.bool,
  range: propTypes.oneOf(['day', 'week', 'month']),
  highlightedDates: propTypes.arrayOf(propTypes.number),
  onMonthChange: propTypes.func,
  showSelectedRange: propTypes.bool,
  changeOnMonthSelection: propTypes.bool,
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

export default DateEditor
